import { useStateUrlParamsArray } from "@common/hooks/useStateUrlParams";
import { useTranslation } from "@localization/useTranslation";
import { useDownloadInternalAssessmentReport } from "../../DownloadInternalAssessmentReport.hooks";
import { InternalAssessmentReportTableProps } from "../InternalAssessmentReportTable.types";
import { useInternalAssessmentReportRows } from "../InternalAssessmentReportTable.hooks";
import { filterBySelection, toSelectOptions } from "@common/components/managementReport/managementReportFilters";

export default function useInternalAssessmentReportInProgressAssessments(props: InternalAssessmentReportTableProps) {
    const { translateLegalEntityAuditStatus } = useTranslation();

    const [searchedStatus, setSearchedStatus] = useStateUrlParamsArray("status", []);
    const [searchedRemindersSent, setSearchedRemindersSent] = useStateUrlParamsArray("remindersSent", []);

    const { onDownloadReportAsPdf, getReportPdfUrl, isDownloadingPdf } = useDownloadInternalAssessmentReport();

    const rows = useInternalAssessmentReportRows(props.assessments);

    const statusFilterOptions = toSelectOptions(
        rows.map((row) => ({ id: row.status.toString(), name: translateLegalEntityAuditStatus(row.status.toString()) }))
    );

    const remindersSentFilterOptions = toSelectOptions(
        rows.map((row) => (row.reminderSent ? { id: row.reminderSentString, name: row.reminderSentString } : undefined))
    );

    let filteredRows = filterBySelection(rows, searchedStatus, (row) => row.status.toString());
    filteredRows = filterBySelection(filteredRows, searchedRemindersSent, (row) => (row.reminderSent ? row.reminderSentString : undefined));

    return {
        rows: filteredRows,
        onDownloadReportAsPdf,
        getReportPdfUrl,
        isDownloadingPdf,
        searchedStatus,
        setSearchedStatus,
        statusFilterOptions,
        searchedRemindersSent,
        setSearchedRemindersSent,
        remindersSentFilterOptions,
    };
}
